import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from "@sentry/angular";

import "hammerjs";
import { VERSION } from 'src/version.const'; // HammerJS

Sentry.init({
  dsn: "https://ae0f4f8f4c8acb20342f605f9978c691@o577284.ingest.us.sentry.io/4507831476682752",
});
Sentry.setTag('v',VERSION);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
